import { ProjectHelper } from '@bimser/common';

interface GetRelatedDocumentObjectsPayload {
	projectName: string;
	formName: string;
	parameters: {
		objectRequestSecretKeys: string[];
	};
	packageVersion: number;
}

const GetRelatedDocumentObjects = (data: GetRelatedDocumentObjectsPayload) =>
	ProjectHelper.RunPromiseFormService({
		projectName: data.projectName,
		formName: data.formName,
		serviceName: 'GetRelatedDocumentObjectsV2',
		requestParameters: data.parameters,
		requestConfig: { cache: true },
		projectVersion: data.packageVersion
	});

export default GetRelatedDocumentObjects;
